export default __webpack_public_path__ + "static/media/tristad.3b100ffb.svg";